export const PAYMENT = '[Payment]'
export const GET_PAYMENTS = `${PAYMENT} GET_PAYMENTS`
export const SET_PAYMENTS = `${PAYMENT} SET_PAYMENTS`
